export class FinancialTransactionFilter {
  CompanyId?: number;
  UserId?: string;
  ModuleId?: number;
  PaymentRequestId?: number;
  IsCreditUpgrade: boolean;

  constructor(companyId?: number, userId?: string, moduleId?: number, paymentRequestId?: number) {
    this.CompanyId = null;
    this.UserId = null;
    this.ModuleId = null;
    this.IsCreditUpgrade = false;

    if (companyId) {
      this.CompanyId = companyId;
    }

    if (userId) {
      this.UserId = userId;
    }

    if (moduleId) {
      this.ModuleId = moduleId;
    }

    if (paymentRequestId) {
      this.PaymentRequestId = paymentRequestId;
    }
  }
}
